<template>
  <section class="sponsors general">
    <div class="sponsors__content">
      <h1 class="sponsors__title">
          Presenting Companies
      </h1>
      <div class="sponsors__logos">
        <template v-for="partner in partners" :key="partner.name">
          <a v-if="partner.url" :href="partner.url" target="_blank">
            <div
              class="sponsors__item single smaller"
            >
              <div class="sponsors__logo-container nobg">
                <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
              </div>
            </div>
          </a>
          <div
            v-else
            class="sponsors__item single smaller"
          >
            <div class="sponsors__logo-container nobg">
              <img :src="partner.logo" :alt="partner.name" :class="partner.class || 'full-logo'">
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@/styles/components/sponsors.scss';
</style>

<script>
import { ref } from 'vue';

export default {
  setup() {
    const partners = ref([
      { logo: require('@/assets/logos/zeebu.png'), class: 'full-logo', name: 'Zeebu', url: 'http://zeebu.com/' },
      { logo: require('@/assets/logos/midnight.svg'), class: 'full-logo', name: 'Midnight', url: 'https://midnight.network/' },
      { logo: require('@/assets/logos/animoca.png'), class: 'full-logo wolf', name: 'Animoca Brands', url: 'https://www.animocabrands.com/' },
      { logo: require('@/assets/logos/kucoin.png'), class: 'full-logo', name: 'Kucoin', url: 'https://www.kucoin.com/kucoin-ventures' },
      { logo: require('@/assets/logos/wellspring.png'), class: 'full-logo', name: 'Wellspring', url: 'https://wellspring.money/' },
      { logo: require('@/assets/logos/antix.png'), class: 'logo libera', name: 'Antix In', url: 'https://antix.in/' },
      { logo: require('@/assets/logos/inception.svg'), class: 'full-logo', name: 'Inception Capital', url: 'https://www.inception.capital/' },
      { logo: require('@/assets/logos/rebelart.png'), class: 'full-logo', name: 'Rebel Art Studios', url: 'https://rebelartstudios.org/' },
      { logo: require('@/assets/logos/barunlaw.png'), class: 'logo', name: 'BARUNLAW LLP', url: 'https://www.barunlaw.com/' },
      { logo: require('@/assets/logos/rise.svg'), class: 'logo', name: 'Rise', url: 'https://risechain.com/' },
      { logo: require('@/assets/logos/makina.svg'), class: 'full-logo', name: 'Makina', url: 'https://makina.finance/' },
      { logo: require('@/assets/logos/pukecast.png'), class: 'full-logo', name: 'Pukecast', url:'https://r3achntwrk.com/pukecast' },
      { logo: require('@/assets/singapore/sponsors/aethir.png'), class: 'logo', name: 'Aethir', url: 'https://aethir.com/' },
      { logo: require('@/assets/logos/cls.svg'), class: 'logo', name: 'CLS', url: 'https://www.cls.global/' },
      { logo: require('@/assets/logos/ivc.png'), class: 'full-logo', name: 'IVC', url: 'https://www.ivcrypto.io/' },
      { logo: require('@/assets/logos/hippo.png'), class: 'full-logo', name: 'Hippo', url: 'https://hippoprotocol.ai/' },
      { logo: require('@/assets/logos/lunar.svg'), class: 'full-logo', name: 'Lunar Digital Assets', url: 'https://www.lunardigitalassets.io/' },
      { logo: require('@/assets/logos/gain.png'), class: 'logo', name: 'Gain', url: 'https://www.gain.ventures/' },
      { logo: require('@/assets/logos/hyper.svg'), class: 'full-logo', name: 'Hyper Corporation', url: 'https://hyper-corp.com/' },
      { logo: require('@/assets/logos/outlaw.png'), class: 'logo libera', name: 'Outlaw', url: 'https://teamoutlaw.io/' },
      { logo: require('@/assets/logos/vnx.png'), class: 'logo libera', name: 'VNX', url: 'https://vnx.li/' },
      { logo: require('@/assets/logos/mirana.png'), class: 'full-logo', name: 'Mirana', url: 'https://www.mirana.xyz/' },
      { logo: require('@/assets/logos/wintermute.svg'), class: 'full-logo', name: 'Wintermute Trading', url: 'https://www.wintermute.com/' },
      { logo: require('@/assets/logos/caladan.png'), class: 'full-logo', name: 'Caladan', url: 'https://caladan.xyz/' },
      { logo: require('@/assets/singapore/sponsors/sapien.png'), class: 'full-logo', name: 'Sapien',  url: 'https://game.sapien.io' },
      { logo: require('@/assets/logos/pact.png'), class: 'logo', name: 'Pact Swap', url: 'https://pactswap.io/' },
      { logo: require('@/assets/logos/zkalyx.png'), class: 'full-logo', name: 'Zkalyx', url: 'https://www.zkalyx.com/' },
      { logo: require('@/assets/logos/raiinmaker.png'), class: 'full-logo', name: 'Raiinmaker', url: 'https://www.raiinmaker.com/' },
      { logo: require('@/assets/korea/sponsors/libera.png'), class: 'logo libera', name: 'Libera Global AI', url: 'https://liberaglobal.ai/' },
      { logo: require('@/assets/logos/matterfi.svg'), class: 'full-logo', name: 'MatterFi', url: 'https://www.matterfi.com/' },
      { logo: require('@/assets/logos/autogames.svg'), class: 'full-logo', name: 'Autogames AI', url: 'https://autogame.ai/' },
      { logo: require('@/assets/logos/estatex.png'), class: 'full-logo', name: 'EstateX', url: 'https://www.estatex.eu/' },
      { logo: require('@/assets/logos/manifest.png'), class: 'full-logo', name: 'Manifest', url: 'https://manifest.network/' },
      { logo: require('@/assets/logos/own.png'), class: 'full-logo', name: 'Own. App', url: 'https://www.ownapp.co/' },
      { logo: require('@/assets/logos/planck.svg'), class: 'full-logo', name: 'Planck', url: 'https://www.plancknetwork.com/' },
      { logo: require('@/assets/logos/backstage.svg'), class: 'full-logo', name: 'Backstage', url: 'https://backstage.global/' },
    ]);
    return {
      partners
    };
  },
};
</script>